module.exports = __webpack_public_path__ + "static/media/video_outer.8edb607d.png";